import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { parametrosDaComparacao } from "../pages/comparativo/comparativoHelpers";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useCollectionBranchKpis({
  branchIds,
  categoriaId,
  categorySource = "erp",
  startDate,
  endDate,
  revenueMode = "presencial",
  enabled = true,
}) {
  const { getCollectionBranches } = useApiV2();
  const { user } = useAuth();
  const params = parametrosDaComparacao({
    branchIds,
    categorySource,
    categoriaId,
    startDate,
    endDate,
    revenueMode,
  });

  const { data, isLoading } = useQuery({
    queryKey: ["collection-branch-comparison", user?.user_id ?? null, params],
    queryFn: () => getCollectionBranches(params),
    enabled: Boolean(
      enabled && categoriaId && startDate && endDate && branchIds?.length
    ),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  return { data, isLoading };
}
